<ng-container *ngFor="let item of errors">
  <!-- Utilizzo *ngIf per gestire il cambiamento del tipo di errore -->
  <div *ngIf="item.checkFn(control)" class="{{item.color}} mt-1" role="alert"
       aria-label="Errore di validazione">{{item.message | translate:item.messageParams}}</div>
</ng-container>
